import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ProgramTable from '@ProgramList/components/ProgramTable.vue';
import ProgramFilters from '@ProgramList/components/ProgramFilters.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ResultsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProgramFilters, { live: true }),
    _createVNode(ProgramTable)
  ]))
}
}

})